import { useState, useEffect } from 'react';
import { useAuth } from '../firebase/useAuth';

interface MarketSentiment {
  sentiment: 'BULLISH' | 'BEARISH' | 'NEUTRAL';
  score: number;
  summary: string;
}

export function useMarketSentiment() {
  const { user } = useAuth();
  const [data, setData] = useState<MarketSentiment | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    const fetchSentiment = async () => {
      try {
        const token = await user.getIdToken();
        const res = await fetch(`${import.meta.env.VITE_API_URL}/api/ai/analysis/sentiment`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          setLoading(false);
          return;
        }
        const json = await res.json();
        if (json.success) setData(json.data);
      } catch {
        // silent fail
      } finally {
        setLoading(false);
      }
    };
    fetchSentiment();
  }, [user]);

  return { data, loading };
}
